import { useState, useCallback } from 'react';
import { VideoState, VideoUIState, VideoModalState, VideoDataState } from '../types/VideoDragList.types';
import { VideoItem } from '../../../utils/videoOperations';

const initialUIState: VideoUIState = {
	draggingIndex : null,
	anchorEl      : null,
	hoveredIcon   : null,
	hideStates    : {}
};

const initialModalState: VideoModalState = {
	share   : false,
	edit    : false,
	delete  : false,
	preview : false
};

const initialDataState: VideoDataState = {
	selectedTab         : 'Details',
	previewUrl          : null,
	activeItemId        : null,
	currentEditingVideo : null,
	videoToDelete       : null
};

export const useVideoState = () =>
{
	const [ state, setState ] = useState<VideoState>({
		ui    : initialUIState,
		modal : initialModalState,
		data  : initialDataState
	});

	const updateUI = useCallback((updates: Partial<VideoUIState>) =>
	{
		setState((prev) => ({
			...prev,
			ui : { ...prev.ui, ...updates }
		}));
	}, []);

	const updateModal = useCallback((updates: Partial<VideoModalState>) =>
	{
		setState((prev) => ({
			...prev,
			modal : { ...prev.modal, ...updates }
		}));
	}, []);

	const updateData = useCallback((updates: Partial<VideoDataState>) =>
	{
		setState((prev) => ({
			...prev,
			data : { ...prev.data, ...updates }
		}));
	}, []);

	const toggleHideState = useCallback((id: string) =>
	{
		setState((prev) => ({
			...prev,
			ui : {
				...prev.ui,
				hideStates : {
					...prev.ui.hideStates,
					[id] : !prev.ui.hideStates[id]
				}
			}
		}));
	}, []);

	const setCurrentEditingVideo = useCallback((video: VideoItem | null) =>
	{
		updateData({ currentEditingVideo: video });
		updateModal({ edit: video !== null });
	}, [ updateData, updateModal ]);

	const setVideoToDelete = useCallback((video: VideoItem | null) =>
	{
		updateData({ videoToDelete: video });
		updateModal({ delete: video !== null });
	}, [ updateData, updateModal ]);

	return {
		state,
		updateUI,
		updateModal,
		updateData,
		toggleHideState,
		setCurrentEditingVideo,
		setVideoToDelete
	};
};